import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)
import { CachedApi } from './CachedApi'
import { orderStore } from '../store/orderStore'

export class ExtraApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	getAccessToken()
	{
		return container.get('services.oauth').getToken()
	}

	tags (params) {
		return Vue.http.get(this.url + '/product/tags', { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		}})
	}

	all (params) {

    if (!params) {
      params = {}
    }

		let c = new CachedApi();

		params.params.shipmentDate = orderStore.state.order ? orderStore.state.order.date.shipment : null

		return c.get(this.url + '/extra', params.params);
	}
}
